// Typed rule registry — README.md "Rules" (12 rules). A `Record<RuleId,
// Rule>` keyed by the full `RuleId` union means a missing entry is a
// compile error, not a runtime gap (AGENTS.md "Registry-completeness
// rule") — completenessRegistry.test.ts also asserts every RuleId is here.

import type { BuildContext } from '../context';
import type { Issue, RuleId } from '../types';
import { checkLay02, checkLay03 } from './layAngles';
import { checkAvr01, checkAvr02 } from './avrDecodeProcessing';
import { checkAvr03, checkAvr04 } from './avrAmp';
import { checkImp01 } from './impedance';
import { checkPwr02 } from './headroom';
import { checkCon02 } from './subwoofer';
import { checkPhy02 } from './rearPort';
import { checkPhy05 } from './frontMatch';
import { checkPrj01 } from './projector';

export interface RuleResult {
  issues: Issue[];
  unknown: { rule: RuleId; productIds: string[] }[];
}

export type Rule = (ctx: BuildContext) => RuleResult;

function noUnknown(fn: (ctx: BuildContext) => Issue[]): Rule {
  return (ctx) => ({ issues: fn(ctx), unknown: [] });
}

export const RULES: Record<RuleId, Rule> = {
  'LAY-02': noUnknown(checkLay02),
  'LAY-03': noUnknown(checkLay03),
  'AVR-01': noUnknown(checkAvr01),
  'AVR-02': noUnknown(checkAvr02),
  'AVR-03': noUnknown(checkAvr03),
  'AVR-04': noUnknown(checkAvr04),
  'IMP-01': checkImp01,
  'PWR-02': checkPwr02,
  'CON-02': noUnknown(checkCon02),
  'PHY-02': checkPhy02,
  'PHY-05': noUnknown(checkPhy05),
  'PRJ-01': checkPrj01,
};

export const RULE_IDS = Object.keys(RULES) as RuleId[];
